import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-compass-fill",
  "use": "icon-compass-fill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-compass-fill\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM327.3 702.4c-2 0.9-4.4 0-5.3-2.1-0.4-1-0.4-2.2 0-3.2l98.7-225.5 132.1 132.1-225.5 98.7z m375.1-375.1l-98.7 225.5-132.1-132.1L697.1 322c2-0.9 4.4 0 5.3 2.1 0.4 1 0.4 2.1 0 3.2z\" p-id=\"9412\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol